// Lib
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

// Components
import Tabs from '../../components/tabs/Tabs';
import Tab from '../../components/tabs/Tab';
import PublishBoardPanel from '../../workspace/header/currentBoardHeader/sharing/popup/publish/PublishBoardPanel';
import BoardEditorPanel from '../../workspace/header/currentBoardHeader/sharing/popup/editing/BoardEditorPanel';
import ErrorToast from '../../components/toast/ErrorToast';

//  Selectors
import { currentBoardUserPermissionsSelector } from '../../utils/permissions/elementPermissionsSelector';

// Types
import { GeneralWorkspaceProps } from '../../workspace/workspaceTypes';

// Styles
import './MobileSharingTabs.scss';

enum ShareTabs {
    ADD_EDITORS = 'ADD_EDITORS',
    READ_ONLY_LINK = 'READ_ONLY_LINK',
}

type MobileSharingTabsProps = GeneralWorkspaceProps & {
    activeTab: ShareTabs;
    userPermission: number;
    setErrorToast: (message: string | null) => void;
};

const MobileSharingTabPanels = (props: MobileSharingTabsProps) => {
    const { activeTab } = props;

    if (activeTab === ShareTabs.ADD_EDITORS) {
        return <BoardEditorPanel {...props} />;
    }

    return <PublishBoardPanel {...props} />;
};

const MobileSharingTabs = (props: GeneralWorkspaceProps & { isSheetOpen: boolean }) => {
    const userPermission = useSelector(currentBoardUserPermissionsSelector);
    const [errorToastMessage, setErrorToastMessage] = useState<string | null>(null);

    // Clear error toast when sheet closes
    useEffect(() => {
        if (!props.isSheetOpen && errorToastMessage) {
            setErrorToastMessage(null);
        }
    }, [props.isSheetOpen, errorToastMessage]);

    return (
        <div className="MobileSharingTabs">
            <Tabs
                initialActiveTab={ShareTabs.ADD_EDITORS}
                tabs={[
                    <Tab tabId={ShareTabs.ADD_EDITORS}>Add editors</Tab>,
                    <Tab tabId={ShareTabs.READ_ONLY_LINK}> Share read-only link</Tab>,
                ]}
            >
                {(activeTab: ShareTabs) => (
                    <MobileSharingTabPanels
                        {...props}
                        activeTab={activeTab}
                        userPermission={userPermission}
                        setErrorToast={setErrorToastMessage}
                    />
                )}
            </Tabs>
            <ErrorToast
                message={errorToastMessage}
                show={!!errorToastMessage}
                groupId="MobileSharingSheet"
                onDismiss={() => setErrorToastMessage(null)}
            />
        </div>
    );
};

export default MobileSharingTabs;
